/*
  Scroll animations for "Section" (sections/section.liquid):
  - Text blocks: left-to-right mask reveal, like the theme's footer and media banner.
  - Elements with .animate-rise (image layers, product card images): rise up into
    place with a small bounce, in sequence, when their container comes into view.
  Items that enter the viewport together are staggered in DOM order.
  Nothing starts until the page has loaded and the store's preloader has faded,
  so animations above the fold are visible on page load.
*/
(function () {
  const STAGGER = 0.15;
  // Full-screen loader injected by a store app; animations wait until it fades out.
  const PAGE_COVER = '.c-preloaderapp';
  const MAX_COVER_WAIT = 5000;

  const pageIsCovered = () => {
    const cover = document.querySelector(PAGE_COVER);
    if (!cover) return false;
    const style = getComputedStyle(cover);
    return style.display !== 'none' && style.visibility !== 'hidden' && Number(style.opacity) > 0.3;
  };

  const whenPageVisible = () =>
    new Promise((resolve) => {
      const start = () => {
        const startedAt = Date.now();
        const check = () => {
          if (!pageIsCovered() || Date.now() - startedAt > MAX_COVER_WAIT) resolve();
          else setTimeout(check, 100);
        };
        check();
      };
      if (document.readyState === 'complete') start();
      else window.addEventListener('load', start, { once: true });
    });
  const RISE_CONTAINERS = '.image-block, .product-feature-card__media';

  const observe = (elements, onEnter, options) => {
    const observer = new IntersectionObserver((entries) => {
      const entering = entries.filter((entry) => entry.isIntersecting).map((entry) => entry.target);
      if (!entering.length) return;
      onEnter(entering);
      entering.forEach((element) => observer.unobserve(element));
    }, options);
    elements.forEach((element) => observer.observe(element));
  };

  const revealText = (blocks) => {
    blocks.forEach((block, index) => {
      block.style.transitionDelay = `${Math.min(index, 5) * STAGGER}s`;
      block.classList.add('is-animated');
      const onEnd = (event) => {
        if (event.target !== block || !event.propertyName.includes('mask')) return;
        block.classList.add('animation-done');
        block.style.transitionDelay = '';
        block.removeEventListener('transitionend', onEnd);
      };
      block.addEventListener('transitionend', onEnd);
    });
  };

  const rise = (containers) => {
    let index = 0;
    containers.forEach((container) => {
      container.querySelectorAll('.animate-rise').forEach((element) => {
        element.style.setProperty('--rise-delay', `${index++ * STAGGER}s`);
        element.classList.add('is-animated');
      });
    });
  };

  const init = (root) => {
    root.querySelectorAll('.layout-section.animate-on-scroll').forEach((section) => {
      if (section.dataset.animateReady) return;
      section.dataset.animateReady = 'true';

      observe(section.querySelectorAll('.text-block'), revealText, { rootMargin: '0px 0px -10% 0px' });

      const containers = new Set(
        [...section.querySelectorAll('.animate-rise')].map((element) => element.closest(RISE_CONTAINERS))
      );
      containers.delete(null);
      observe([...containers], rise, { threshold: 0.3 });
    });
  };

  whenPageVisible().then(() => init(document));

  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
